<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="justify-content-start mb-5">
        <b-col cols="4" lg="2" xl="1">
          <back-button :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <bic-form :mode="mode" :readonly="!isEditable" v-model="config" v-else></bic-form>
      <b-row class="justify-content-end">
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('details')">
            <span>{{ $t('common.cncl') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="switchMode('edit')">
            <i class="fa-light fa-pencil"></i>
            <span>{{ $t('administration.edit') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="!isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="deleteBic">
            <i class="fa-light fa-trash"></i>
            <span>{{ $t('rights.delete') }}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="isEditable && formType !== 'add'">
          <b-button variant="primary"
            @click="editBic">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
        </b-col>
        <b-col cols="4" lg="2" xl="1" v-if="mode === 'add'">
          <b-button variant="primary"
            @click="addBic">
            <i class="fa-light fa-save"></i>
            <span>{{$t('common.sve')}}</span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'
import BicForm from '@/pages/bic/BicForm.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: "BicDetails",
  components: {
    'back-button': backButton,
    'bic-form': BicForm,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "add"
    },
    id: {
      type: String,
      default: '-1'
    }
  },
  computed: {
    isEditable () {
      return this.formType === 'add' || this.formType === 'edit'
    },
    pageTitle() {
      switch (this.mode) {
        case 'edit':
          return this.$t('Webheader.bic_edit');
        case 'details':
          return this.$t('Webheader.bic_details');
        case 'add':
        default:
          return this.$t('Webheader.bic_add');
      }
    }
  },
  data() {
    return {
      activateSpinner: false,
      bic: '',
      returnUrl: '',
      currentBic: {},
      savedConfig: [],
      config: {},
      originalConfig: {},
      formType: 'add'
    }
  },
  created() {
    this.activateSpinner = true
    this.formType = this.mode

    this.bicGroupId = this.$route.query.groupId
    this.returnUrl = 'bic/bic/' + this.bicGroupId

    if(this.id !== '-1' && (this.mode === "details" || "edit")) {
      this.getBic()
    } else {
      this.activateSpinner = false
    }
  },
  methods: {
    addBic () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        BicCode: this.config.BicCode,
        IdBicGroup: this.bicGroupId,
        id: this.id
      }
      this.$engine.bic.bic.create(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_added'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'bic/bic/' + that.bicGroupId})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.bic.bic_addition_error'))
      })
    },
    deleteBic () {
      let that = this
      this.$f7.modal({
        title: this.$t('common.bic.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = {
                IdBic: that.id
              }
              that.$engine.bic.bic.delete(params)
              .then(resp => {
                that.$f7.modal({
                  title: that.$t('common.bic.bic_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, {url: 'bic/bic/' + that.bicGroupId })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.bic.bic_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    editBic () {
      let that = this
      let params = {
        BicCode: this.config.BicCode,
        IdBicGroup: this.bicGroupId,
        IdBic: this.id
      }
      this.$engine.bic.bic.edit(params)
      .then(resp => {
        that.$f7.modal({
          title: that.$t('common.bic.bic_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: 'bic/bic/' + that.bicGroupId })
      })
      .catch(e => {
        errorMessageAlert(e, that)
        that.okMessageBox(that.$t('common.bic.bic_edition_error'))
      })
    },
    fillFields () {
      this.config = this.currentBic
      this.originalConfig = this.currentBic
      this.activateSpinner = false
    },
    formHasError () {
      if (this.config.BicCode === undefined || this.config.length === 0) {
        this.okMessageBox(this.$t('common.bic.bic_code_missing'))
        return true
      }
      return false
    },
    getBic () {
      let that = this
      this.$engine.bic.bic.fetch({id: this.id})
      .then(resp => {
        let bicList = {}

        bicList = resp.data.Bic
        that.updateBic(bicList)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchMode (mode) {
      if (mode === 'details' && this.formType === 'edit') {
        this.config = this.originalConfig
      }
      this.formType = mode
    },
    updateBic (bicList) {
      const selectedBic = bicList.find(bic => bic.IdBic === this.id)
      this.currentBic = selectedBic
      this.fillFields()
    }
  }
}
</script>
